import Box, { type BoxProps } from '@mui/material/Box';
import type { SvgIconProps } from '@mui/material/SvgIcon';
import { useTranslation } from '@tyro/i18n';
import { CheckmarkCircleBigIcon } from '@tyro/icons';

export interface TableBooleanValueProps {
  value: boolean;
  'aria-label'?: string;
  trueProps?: SvgIconProps;
  falseProps?: BoxProps;
}

export function TableBooleanValue({
  value,
  'aria-label': ariaLabel,
  trueProps = {},
  falseProps = {},
}: TableBooleanValueProps) {
  const [t] = useTranslation(['common']);

  return value ? (
    <CheckmarkCircleBigIcon
      aria-label={ariaLabel ?? t('common:yes')}
      sx={{ color: 'emerald.500' }}
      {...trueProps}
    />
  ) : (
    <Box
      aria-label={ariaLabel ?? t('common:no')}
      component="span"
      color="slate.300"
      {...falseProps}
    >
      -
    </Box>
  );
}
